module.exports = __webpack_public_path__ + "img/arrow-l-w.3a55ce0d.svg";